import constants from 'Constants';


export function formatAmountDisplay(value, currency=null, withPrefix=true, native=false) {
  if (!parseFloat(value) && parseFloat(value) !== 0) value = 0;
  let newValue = parseFloat(value).toFixed(2);
  newValue = newValue.replace(".00", "");
  newValue = newValue.toLocaleString();

  if (!withPrefix) return newValue;
  if (!currency) return `$${newValue}`;

  const option = constants.CURRENCY_OPTIONS.filter((option) => option.value === currency)[0];
  if (!option) return `$${newValue}`;
  return `${option.symbol}${newValue}`;
}



